export enum SeparatorEnum {
  COMMA = ',',
  SLASH = '/',
  DOT = '.',
  HYPHEN = '-',
  UNDERSCORE = '_',
  COLON = ':',
}
